import { Tooltip } from "react-migration/components/Tooltip";
import { Theme } from "react-migration/lib/theme/Theme";
import clsx from "clsx";

export const InfoTooltip = ({
  content,
  tooltipContent,
  dataTestId,
  justifyContent = "normal",
  icon = "icon-lt-information-line",
  iconSize = "text-lg",
  iconColor = "text-text-base-active",
}: {
  content: string;
  tooltipContent: string;
  dataTestId: string;
  justifyContent?: "center" | "start" | "end" | "between" | "normal";
  icon?: string;
  iconSize?: string;
  iconColor?: string;
}) => {
  return (
    <div className={clsx("flex items-center w-full gap-x-1", `justify-${justifyContent}`)} data-testid={dataTestId}>
      <span>{content}</span>
      <Tooltip.Wrapper>
        <Tooltip.Trigger>
          <i
            className={clsx(icon, iconSize, iconColor, "cursor-pointer pointer-events-auto")}
            data-testid="info-tooltip-trigger"
          />
        </Tooltip.Trigger>
        <Tooltip.Content align="center" side="bottom" theme={Theme.Dark} size="sm">
          <span className="whitespace-normal">{tooltipContent}</span>
        </Tooltip.Content>
      </Tooltip.Wrapper>
    </div>
  );
};
